import axiosConfig from "./axiosConfig";
import { OtherChargeItem } from "./postSiteBilling";

export interface TransferReadingFileRef {
  file_guid: string;
  file_name: string;
}

export interface ImportInvoiceRequest {
  month?: string;
  files?: TransferReadingFileRef[];
  generate_invoice?: boolean;
  invoice_format?: "pdf" | "docx";
  invoice_date?: string; // YYYY-MM-DD
  other_charge_items?: OtherChargeItem[];
}

export interface ImportInvoiceResponse {
  operationKey: string;
  status: "pending" | "running";
}

export interface ImportInvoiceOperationResult {
  file_results: Array<Record<string, unknown>>;
  invoice_data: Record<string, unknown> | null;
  files_attached: Array<{ fileName: string }>;
}

const postImportInvoice = async (
  authToken: string,
  siteId: string,
  request: ImportInvoiceRequest
): Promise<ImportInvoiceResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/import-invoice`,
    request,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postImportInvoice;
